module.exports = __webpack_public_path__ + "img/img_banner_join.e363d866.jpg";